import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import { useLanguage } from '../../context/LanguageContext';
import './NotFound.css';

const NotFound = () => {
  const { lang, t } = useLanguage();

  return (
    <>
      <SEO
        title={t.notFound.title}
        description={t.notFound.description}
        noIndex={true}
        lang={lang}
      />
      <div className="page not-found-page">
        <h1>{t.notFound.title}</h1>
        <p>{t.notFound.description}</p>
        <Link to={`/${lang}`} className="back-link">{t.notFound.backLink}</Link>
      </div>
    </>
  );
};

export default NotFound;
